module.exports = __webpack_public_path__ + "img/logo.16060a05.svg";